import { render, staticRenderFns } from "./JPrompt.vue?vue&type=template&id=2398a313&scoped=true&"
import script from "./JPrompt.vue?vue&type=script&lang=js&"
export * from "./JPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398a313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2398a313')) {
      api.createRecord('2398a313', component.options)
    } else {
      api.reload('2398a313', component.options)
    }
    module.hot.accept("./JPrompt.vue?vue&type=template&id=2398a313&scoped=true&", function () {
      api.rerender('2398a313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JModal/JPrompt.vue"
export default component.exports